import { payCyclesService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

// Fetches the raw pay cycles for a calendar (no holiday/working-day augmentation) so the dashboard
// can derive the last/next pay day and cut-off by date.
const useFetchAllPayCycles = (payCalendarId?: string) => {
  return useQuery({
    queryKey: ['fetchAllPayCycles', payCalendarId],
    queryFn: () =>
      payCyclesService.fetchPayCycles({ payCalendarId: payCalendarId || '', page: 0, size: 500 }),
    enabled: !!payCalendarId,
  });
};

export default useFetchAllPayCycles;
